export default "__VITE_ASSET__D_fF_qJI__"